import React from 'react';
import moment from 'moment';
import { Briefcase, Globe } from 'lucide-react';
import { Badge } from 'src/shared/components/ui/badge';
import { SiteStatus } from 'src/app/site-nature-risk/state/api/siteStatus';

type IsicCodeDetail = {
    code: string;
    description: string;
};

type SiteContextLineProps = {
    countryName: string | null;
    activity: { isicDetail: IsicCodeDetail | null } | null | undefined;
    status?: SiteStatus;
    archivedAt?: string | null;
};

const SiteContextLine = ({ countryName, activity, status, archivedAt }: SiteContextLineProps) => {
    const isicDetail = activity?.isicDetail ?? null;
    const activityLabel = isicDetail ? `[${isicDetail.code}] ${isicDetail.description}` : null;
    const isArchived = status === SiteStatus.ARCHIVED;
    const isDraft = status === SiteStatus.DRAFT;

    if (!countryName && !activityLabel && !isArchived && !isDraft) return null;

    return (
        <div className='flex items-center gap-4 text-sm text-muted-foreground' data-testid='site-context-line'>
            {countryName && (
                <span className='flex items-center gap-1.5'>
                    <Globe size={14} className='shrink-0' />
                    {countryName}
                </span>
            )}
            {activityLabel && (
                <span className='flex items-center gap-1.5'>
                    <Briefcase size={14} className='shrink-0' />
                    {activityLabel}
                </span>
            )}
            {isArchived && (
                <Badge variant='error' data-testid='site-archived-badge'>
                    {archivedAt ? `Archived: ${moment.utc(archivedAt).format('D MMMM YYYY')}` : 'Archived'}
                </Badge>
            )}
            {isDraft && (
                <Badge variant='outline' data-testid='site-draft-badge'>
                    Draft
                </Badge>
            )}
        </div>
    );
};

export default SiteContextLine;
